import styled from 'styled-components';

const FormStyle = styled.form`
    fieldset {
        border: none;
    }

    .MuiInputBase-input::placeholder {
        font-style: italic; /* Make placeholder text italic */
    }

    .MuiInputBase-input {
        padding: 10px 20px;
    }

    /* Tighter vertical rhythm for invoice popup */
    .mt-f-22 {
        margin-top: 16px;
    }
    .mb-20 {
        margin-bottom: 12px;
    }
    .mt-20 {
        margin-top: 12px;
    }
`;

export default FormStyle;
